<template>
    <div v-if="!loading && orders" class="w-full flex flex-column gap-3">
        <div class="flex gap-2 flex-wrap">
            <AddOrder @added="loadOrders"/>
            <Button label="Экспорт" icon="pi pi-download" @click="exportCSV()" severity="secondary" size="small" class="flex"/>
            <Button label="Обновить" icon="pi pi-refresh" @click="loadOrders" severity="secondary" size="small" class="flex"/>
            <Button label="Сбросить" icon="pi pi-times" @click="resetFilters" severity="secondary" size="small" class="flex"/>
        </div>
        <DataTable ref="dt" :value="orders" responsiveLayout="scroll" v-model:filters="lazyParams.filters" 
            v-model:selection="selectedRows" selectionMode="multiple"
            @page="onPage($event)" @sort="onSort($event)" @filter="onFilter($event)" 
            :globalFilterFields="globalFields" lazy filterDisplay="menu" 
            :rows="lazyParams.rows" :totalRecords="totalRecords" :loading="loading" >

            <template #header>
                <div class="text-sm flex flex-row gap-2 text-600 font-medium">
                    <span class="flex my-auto py-2">Итого: {{ totalRecords }}</span>
                    <span v-if="selectedRows && selectedRows.length>0" class="flex my-auto">
                        Выбрано: {{ selectedRows.length }} на сумму {{ getFormatAmount(getSelectedAmount(), 'rub') }}
                    </span>
                    <Button @click="copy(getSelectedAmount())" v-if="selectedRows && selectedRows.length>0"
                        icon="pi pi-copy" iconPos="right" text severity="secondary" class="flex text-xs" size="small"/>
                </div>
            </template>

            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>

            <Column field="_id" header="" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="false">
                <template #header>
                    <span class="text-xs font-medium">ID</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <div class="text-sm flex flex-row gap-1">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ (data.id) }}
                            </span>
                        </span>...
                        <Button @click="copy(data.id)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                    </div>
                </template>
            </Column>

            <Column field="id" header="" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="true" class="hidden"></Column>

            <Column field="client_id" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">Клиент</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <div class="text-sm flex flex-row gap-1">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ data.client_id }}
                            </span>
                        </span>...
                        <Button @click="copy(data.client_id)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                        <!-- <Button @click="copy(filterUser.client_id)" icon="pi pi-filter" iconPos="right" text severity="info" class="text-xs" size="small"/> -->
                    </div>
                </template>
            </Column>

            <Column field="status" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false">
                <template #header>
                    <span class="text-xs font-medium">Статус</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <Select v-model="filterModel.value" @change="filterCallback()" :options="statuses" placeholder="Все" class="p-column-filter" :showClear="false">
                        <template #option="slotProps">
                            <Tag :value="getStatusTitle(slotProps.option)" class="text-xs" :severity="getStatusSeverity(slotProps.option)"
                                :class="(slotProps.option=='confirmed') ? 'bg-green-500 text-green-100' : ''" />
                        </template>
                    </Select>
                </template>
                <template #body="{ data }">
                    <Tag :value="getStatusTitle(data.status)" class="text-xs" :severity="getStatusSeverity(data.status)"
                        :class="(data.status=='confirmed') ? 'bg-green-500 text-green-100' : ''" />
                </template>
            </Column>
            
            <Column field="">
                <template #header>
                    <span class="text-xs font-medium">Действия</span>
                </template>
                <template #body="{ data }">
                    <div class="flex flex-row gap-1">
                        <Button label="Проверить" @click="CheckOrderStatus(data.id)" :loading="loading_" class="text-xs" size="small" severity="info" outlined icon="pi pi-check"/>
                        <Button @click="openDetails(data)" class="" size="small" severity="secondary" icon="pi pi-eye" outlined/>
                        <Button v-if="data.status === 'paid'" @click="openRefund(data)" class="" size="small" severity="danger" outlined icon="pi pi-replay"/>
                    </div>
                </template>
            </Column>

            <Column field="amount">
                <template #header>
                    <span class="text-xs font-medium">Сумма</span>
                </template>
                <template #body="{ data }">
                    <span v-if="data.amount" class="white-space-nowrap flex flex-row gap-1 align-items-center">
                        <span class="white-space-nowrap">
                            {{ getFormatAmount(data.amount, 'rub') }}
                        </span>
                        <Button @click="copy(data.amount)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                    </span>
                </template>
            </Column>

            <!-- <Column field="bank_code" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false">
                <template #header>
                    <span class="text-xs font-medium">Банк</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <Select v-model="filterModel.value" @change="filterCallback()" :options="banks" optionValue="value" optionLabel="label" placeholder="Все" class="p-column-filter" :showClear="true"/>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ getBankLabel(data.bank_code) }}</span>
                </template>
            </Column> -->

            <Column field="created_at" filterField="created_at" dataType="date" :showFilterMatchModes="false" :showFilterOperator="false" >
                <template #header>
                    <span class="text-xs font-medium">Дата создания</span>
                </template>
                <template #filter="{ filterModel }">
                    <DatePicker v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" showTime hourFormat="24" fluid/>
                </template>
                <template #body="{ data }">
                    <span class="text-xs flex white-space-nowrap">
                        {{ formatDate(data.created_at) }}
                    </span>
                </template>
            </Column>

            <Column field="subscription_id" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">Подписка</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <div v-if="data.subscription_id" class="text-sm flex flex-row gap-1">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ data.subscription_id }}
                            </span>
                        </span>...
                        <Button @click="copy(data.subscription_id)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                        <Button @click="goToSubscription(data.subscription_id)" icon="pi pi-external-link" iconPos="right" text severity="info" class="text-xs" size="small"/>
                    </div>
                </template>
            </Column>

            <Column field="ext_order_id" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">Внешний ID</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <div v-if="data.ext_order_id" class="text-sm flex flex-row">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ data.ext_order_id }}
                            </span>
                        </span>
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:7em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ getShort(data.ext_order_id, 6) }}
                            </span>
                        </span>
                        <Button @click="copy(data.ext_order_id)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                    </div>
                </template>
            </Column>

            <Column field="payment_url">
                <template #header>
                    <span class="text-xs font-medium">URL</span>
                </template>
                <template #body="{ data }">
                    <div v-if="data.payment_url" class="text-sm flex flex-row">
                        <!-- <span class="text-xs flex my-auto overflow-hidden" style="max-width:5em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                <a :href="data.payment_url" target="_blank" class="flex text-blue-600">{{ data.payment_url }}</a>
                            </span>
                        </span>... -->
                        ...
                        <Button @click="copy(data.payment_url)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                    </div>
                </template>
            </Column>

            <Column field="description">
                <template #header>
                    <span class="text-xs font-medium">Описание</span>
                </template>
                <template #body="{ data }">
                    <div v-if="data.description" class="text-sm flex flex-row gap-1">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:10em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ (data.description) }}
                            </span>
                        </span>...
                        <Button @click="copy(data.description)" icon="pi pi-copy" iconPos="right" text severity="secondary" class="text-xs" size="small"/>
                    </div>
                </template>
            </Column>

            <Column field="refund_status" :showFilterMenu="false" :showFilterMatchModes="false" :showApplyButton="false">
                <template #header>
                    <span class="text-xs font-medium">Статус возврата</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <Select v-model="filterModel.value" @change="filterCallback()" :options="refundStatuses" placeholder="Все" class="p-column-filter" :showClear="false"/>
                </template>
                <template #body="{ data }">
                    <Tagv v-if="data.refund_status" 
                        :value="getStatusTitle(data.refund_status)" class="text-xs" :severity="getStatusSeverity(data.refund_status)" />
                </template>
            </Column>

            <Column field="ext_refund_id" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false">
                <template #header>
                    <span class="text-xs font-medium">ID возврата</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs">{{ data.ext_refund_id }}</span>
                </template>
            </Column>

            <template #footer>
                <div class="text-sm flex flex-row gap-2 text-600 font-medium">
                    <span class="flex my-auto py-2">Итого: {{ totalRecords }}</span>
                    <span v-if="selectedRows && selectedRows.length>0" class="flex my-auto">
                        Выбрано: {{ selectedRows.length }} на сумму {{ getFormatAmount(getSelectedAmount(), 'rub') }}
                    </span>
                    <Button @click="copy(getSelectedAmount())" v-if="selectedRows && selectedRows.length>0"
                        icon="pi pi-copy" iconPos="right" text severity="secondary" class="flex text-xs" size="small"/>
                </div>
            </template>
        </DataTable>
        <Paginator v-model:first="lazyParams.first" :rows="lazyParams.rows" :totalRecords="totalRecords" 
            template="FirstPageLink  PageLinks LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 30, 50, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000]" 
            @page="onPage"/>
            
        <PersonalOrderDetails v-model="details.visible" :order-id="details.id" />
        <PersonalOrderRefund v-model="refund.visible" :order-id="refund.id" @refunded="onOrderRefunded" />
    </div>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import PersonalOrderDetails from '@/components/personal/order_details.vue'
import PersonalOrderRefund from '@/components/personal/order_refund.vue'
import BigNumber from 'bignumber.js'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import AddOrder from '@/components/personal/add_order.vue'

export default {
    props: {
        orders: {
            type: Array,
            required: true
        },
        users: {
            type: Array,
            default: []
        },
        totalRecords: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        },
        defaultParams: {
            type: Object,
            default: () => ({})
        },
        filters: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['filter', 'lazyParams'],
    data() {
        return {
            loading_: false,
            lazyParams: this.defaultParams,
            selectedRows: [],
            sort: {
                field: '_id',
                order: -1
            },
            globalFields: ['_id', 'user_id', 'client_id', 'project_id', 'status', 'bank_code', 'created_at'],
            statuses: ['pending', 'paid', 'confirmed', 'canceled', 'failed', 'expired', 'refunded'],
            banks: [
                {
                    value: 'dolinsk_bank',
                    label: 'Dolinsk Bank'
                },
                {
                    value: 'kanyonpay',
                    label: 'KanyonPay'
                },
                {
                    value: 'easy_pay',
                    label: 'Easy Pay'
                }
            ],
            projects: [
                {
                    value: '699ea1f3c9b225f0e92393c6', 
                    label: 'X-HUB'
                },
                {
                    value: '699ead66c13e000266f72745',
                    label: 'PaySido'
                }
            ],
            dt: null,
            edit: {
                visible: false,
                id: null,
                status: null,
            },
            refund: {
                visible: false,
                id: null,
            },
            details: {
                visible: false,
                id: null,
            },
            bulk: {
                visible: false,
                ids: []
            }
        }
    },
    computed: {
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
    },
    components: {
        PersonalOrderDetails,
        PersonalOrderRefund,
        AddOrder
    },
    methods: {
        getShort(text, length){
            if(text.length <= length) return text
            return '...' + text.substring(text.length - length)
        },
        resetFilters(){
            this.lazyParams.filters = {
                _id:         {value: '', matchMode: 'contains'}, 
                user_id:    {value: '', matchMode: 'contains'},
                client_id:  {value: '', matchMode: 'contains'},
                ext_order_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                subscription_id: {value: '', matchMode: 'contains'},
                status:     {value: '', matchMode: 'contains'},
                bank_code:  {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            }
            this.$emit('filter', this.lazyParams.filters)
        },
        getProjectLabel(project_id){
            const project = this.projects.find(p => p.value === project_id)
            return (project) ? project.label : project_id
        },
        getBankLabel(bank_code){
            const bank = this.banks.find(b => b.value === bank_code)
            return (bank) ? bank.label : bank_code
        },
        getFormatAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        getStatusSeverity(status) {
            return this.helper.getStatusSeverity(status)
        },
        getStatusTitle(status) {
            return this.helper.getStatusTitle(status)
        },
        isUserInGroup(user, group) {
            return this.helper.isUserInGroup(user, group)
        },
        formatDate(dateStr){
            return this.helper.formatDate(dateStr)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        onPage(event) {
            this.lazyParams.first = event.first
            this.lazyParams.rows = event.rows
            this.lazyParams.page = event.page
            this.lazyParams.pageCount = event.pageCount
            this.$emit('lazyParams', this.lazyParams)
        },
        onSort(event) {
            if(event.sortField && event.sortOrder){
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: '_id',
                    order: -1
                }
            }
            this.lazyParams.sort = this.sort
            this.$emit('lazyParams', this.lazyParams)
        },
        onFilter(params) {
            this.lazyParams.filters = params.filters
            this.$emit('filter', params.filters)
        },
        loadOrders(){
            this.$emit('lazyParams', this.lazyParams)
        },
        filterUser(id){
            let params = this.lazyParams
            params.filters.user_id = {value: id, matchMode: 'contains'}
            this.onFilter(params)
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        exportCSV(){
            this.$refs.dt.exportCSV();
        },
        async CheckOrderStatus(id) {
            this.loading_ = true
            try {
                const resp = await this.connect.GetPersonalOrderStatus(id).then(res=>res)
                if (resp.result && resp.data) {
                    const status = (resp.data.status) ? resp.data.status : 'unknown'
                    let message = (resp.data.message) ? `${resp.data.message} \n` : `Статус: ${status} \n`
                    const payDataFullname = (resp.data.pay_data && resp.data.pay_data.fullname) ? resp.data.pay_data.fullname : null
                    const payDataPhone = (resp.data.pay_data && resp.data.pay_data.phone) ? resp.data.pay_data.phone : null
                    if(payDataFullname) message += `${payDataFullname}`
                    if(payDataPhone) message += ` (${payDataPhone})`
                    this.$toast.add({ severity: this.getStatusSeverity(status), summary: this.getStatusTitle(status), detail: message, life: 3000 })
                } else {
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: 'Не удалось получить статус', life: 1500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading_ = false
            }
        },
        getUserById(user_id){
            if(!this.users || this.users.length === 0) return null
            return this.users.find(user => user.id === user_id)
        },
        openEdit(order){
            this.edit.id = order.id
            this.edit.status = order.status
            this.edit.visible = true
        },
        openRefund(order){
            this.refund.id = order.id
            this.refund.visible = true
        },
        openDetails(order){
            // Детали запрашиваем отдельно, чтобы попап всегда получал актуальные данные.
            this.details.id = order.id
            this.details.visible = true
        },
        openBulkStatus(){
            if(!this.selectedRows || this.selectedRows.length===0) return
            this.bulk.ids = this.selectedRows.map(o => o.id)
            this.bulk.visible = true
        },
        onOrderSaved(payload){
            if (!payload || !payload.id) return
            const idx = this.orders.findIndex(o => o.id === payload.id)
            if (idx !== -1) this.orders[idx] = { ...this.orders[idx], status: payload.status }
            this.edit.visible = false
        },
        onOrderRefunded(payload){
            if (!payload || !payload.id) return
            const idx = this.orders.findIndex(o => o.id === payload.id)
            if (idx !== -1) this.orders[idx] = { ...this.orders[idx], status: payload.status }
            this.refund.visible = false
        },
        getSelectedAmount() {
            let sum = new BigNumber(0)
            if(this.selectedRows && this.selectedRows.length > 0){
                for (let i = 0; i < this.selectedRows.length; i++) {
                    const amount = (this.selectedRows[i].amount && this.selectedRows[i].amount) ? new BigNumber(this.selectedRows[i].amount) : new BigNumber(0)
                    if(this.account_id){
                        if(this.account_id == this.selectedRows[i].to_account_id) sum = sum.plus(amount)
                        else sum = sum.minus(amount)
                    } else sum = sum.plus(amount)
                }
            }
            return sum.toString()
        },
        goToSubscription(id){
            if(!id) return
            window.open(`/personal/subscriptions/?id=${id}`, '_blank')
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.dt = this.$refs.dt
    }
}
</script>